class VideoContent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initElements();
        this.initEvents();
        this.currentStatus = "play";
    }

    initElements() {
        this.playButton = this.querySelector("[data-video-button]");
        this.contentForReplace = this.querySelector("[data-video-content-for-replace]");
        this.playIcon = this.playButton.querySelector("[data-video-button-play]");
        this.pauseIcon = this.playButton.querySelector("[data-video-button-pause]");
    }

    initEvents() {
        this.playButton.addEventListener("click", () => {
            if (!this.contentChanged) {
                this.insertContent();
            }

            this.changeIcon();
        })
    }

    insertContent() {
        const videoContent = this.querySelector("[data-video-content]");

        if (!videoContent) {
            return null;
        }
        const content = document.createElement("div");

        this.contentChanged = true;
        content.appendChild(videoContent.content.firstElementChild.cloneNode(true));
        this.contentForReplace.innerHTML = content.innerHTML;
        videoContent.remove();
        this.video = this.querySelector("[data-video]");

        this.video.addEventListener("click", () => {
            this.changeIcon();
        })
    }

    changeIcon() {
        if (this.currentStatus === "play") {
            this.currentStatus = "pause"
            this.playIcon.classList.add("hidden");
            this.video.play();
        }
        else {
            this.currentStatus = "play"
            this.playIcon.classList.remove("hidden");
            // this.pauseIcon.classList.add("hidden");
            this.video.pause();
        }
    }
}

if (!customElements.get("video-content")) {
    customElements.define("video-content", VideoContent);
}